/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

/**
 * The internal form control layer (DES-1772): one implementation of the
 * label, the required indicator, the help text and the error message shared
 * by the form input components, plus the ARIA wiring that ties them to the
 * control. Internal only - not exported from the package index - so a future
 * public field API can be built on top without being constrained by it.
 */

export { FormFieldLabel } from './FormFieldLabel';
export { FormFieldMessage } from './FormFieldMessage';
export {
  FormFieldGroupContext,
  type FormFieldGroupContextValue,
  useFormFieldGroup,
} from './form-field-group-context';
export type {
  FormFieldControlProps,
  FormFieldMessageSeverity,
  FormFieldProps,
  FormFieldSize,
  FormFieldState,
} from './form-control-types';
export { useFormField } from './use-form-field';
export { useInlineFieldLabel } from './use-inline-field-label';
